import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/medica-2025")({
  head: () => buildRouteHead("/medica-2025", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/events", replace: true });
  },
});
